import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import { Calendar, User, ArrowRight, Tag, Loader2 } from "lucide-react";
import { blogApi } from "../lib/api";

const fmt = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
};

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    blogApi.list(true).then((data) => { setPosts(data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <>
      <PageHeader
        title="Insights, Guides & Case Studies"
        subtitle="Practical articles on ISO standards, data privacy, quality, food safety and information security   from LIS consultants."
        crumbs={[{ label: "Blog" }]}
      />

      <section className="section-pad bg-white">
        <div className="lis-container">
          {loading ? (
            <div className="flex items-center justify-center py-24 text-slate-500"><Loader2 className="animate-spin mr-2" /> Loading articles...</div>
          ) : posts.length === 0 ? (
            <div className="text-center py-24 text-slate-500">No published articles yet. Check back soon.</div>
          ) : selected ? (
            <article className="max-w-3xl mx-auto">
              <button onClick={() => setSelected(null)} className="text-sm text-brand font-semibold mb-4">  Back to all articles</button>
              <span className="chip"><Tag size={12} /> {selected.tag}</span>
              <h1 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900 leading-tight">{selected.title}</h1>
              <div className="mt-3 flex items-center gap-4 text-sm text-slate-500">
                <span className="flex items-center gap-1.5"><Calendar size={14} /> {fmt(selected.created_at)}</span>
                <span className="flex items-center gap-1.5"><User size={14} /> {selected.author}</span>
              </div>
              {selected.image && <img src={selected.image} alt={selected.title} className="mt-6 w-full h-80 object-cover rounded-2xl" />}
              <div className="mt-6 prose max-w-none text-slate-700 whitespace-pre-line leading-relaxed">{selected.content}</div>
            </article>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {posts.map((post) => (
                <article key={post.slug} className="rounded-2xl overflow-hidden border border-slate-100 bg-white card-hover flex flex-col cursor-pointer" onClick={() => setSelected(post)}>
                  <div className="relative h-52 overflow-hidden">
                    {post.image && <img src={post.image} alt={post.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />}
                    <span className="absolute top-3 left-3 chip"><Tag size={12} /> {post.tag}</span>
                  </div>
                  <div className="p-6 flex-1 flex flex-col">
                    <div className="flex items-center gap-4 text-xs text-slate-500">
                      <span className="flex items-center gap-1.5"><Calendar size={12} /> {fmt(post.created_at)}</span>
                      <span className="flex items-center gap-1.5"><User size={12} /> {post.author}</span>
                    </div>
                    <h3 className="mt-3 text-lg font-bold text-slate-900 leading-snug">{post.title}</h3>
                    <p className="mt-2 text-sm text-slate-600 flex-1">{post.excerpt}</p>
                    <button className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-brand text-left">
                      Read article <ArrowRight size={14} />
                    </button>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default BlogPage;
